module.exports = {"210114001":"迎宾路街道","210114003":"陵西街道","210114005":"于洪街道","210114007":"北陵街道","210114009":"沙岭街道","210114010":"南阳湖街道","210114011":"城东湖街道","210114012":"平罗街道","210114013":"马三家街道","210114014":"造化街道","210114015":"大兴街道","210114016":"光辉街道","210114401":"马三家强制隔离戒毒所","210114402":"光辉农场","210114404":"监狱城"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210114.json
// module id = 460
// module chunks = 0